// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
import queryString from "query-string";
import { HttpResult } from "../http";
import LeadPreview from "../../model/LeadPreview";
import NewLead from "../../model/NewLead";
const BASE_URI = "/leads";

export default {
  /**
   * Gets all businesses from backend server
   * @param searchText
   */
  quicksearch(searchText: string) {
    const filter = {
      searchText: searchText,
      pageSize: 20,
      pageNumber: 1,
    };
    const url = BASE_URI + "/search/?" + queryString.stringify(filter);
    return backend.get(url);
  },

  /**
   * Gets the business reference data
   * @returns {object} - The business reference data
   */
  getReferenceData() {
    return backend.get("/leadreferencedata");
  },

  /**
   * Gets leads by emails from backend server
   * @param {string} emails - emails
   * @returns {Promise}  List of LeadPreview
   */
  getLeadsByEmails(emails: string[]): Promise<HttpResult<LeadPreview[]>> {
    const url = "/emailmessageleads/bymails";
    return backend.post(url, emails);
  },

  /**
   * Creates a new lead on the backend server
   * @param {object} newLead - Lead creation info
   * @returns {Promise} Lead Id
   */
  createLead(newLead: NewLead): Promise<any> {
    return backend.post(BASE_URI, newLead);
  },
};
